import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllApprovalList } from "../../../../services/fetchListingData";
import secureStorage from "../../../../services/secureStorage";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import {
  ACTIVE,
  ADMIN,
  ADMIN_USER,
  APPROVED,
  PENDING,
  RNC,
  RNCAPPROVED,
  SALES,
} from "../../../../utility/constants/valueConstants";
import ResizeListner from "../../../../utility/ResizeListner";
import {
  ApprovedListHeaders,
  ApprovedListHeadersAdmin,
  ApprovedListHeadersRnc,
  PendingListHeaders,
} from "../../../../utility/TableHeaders";
import CustomModal from "../../../components/main_comps/custom_modal";
import CustomTable from "../../../components/main_comps/custom_table";
import ViewMoreApproval from "../../../components/ui_comps/approval_comps/ViewMoreApproval";

function Approved({ onChange, status }) {
  const { width, height } = ResizeListner();
  const [data, setData] = useState([]);
  const [totalElements, setTotalElements] = useState(100);
  const [totalPages, setTotalPages] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const dispatch = useDispatch();
  const [clientData, setClientData] = useState(false);
  const [onClickViewMore, setOnClickViewMore] = useState("");
  const approvalData = useSelector((state) => state.listingSlice.approvalList);
  const role = secureStorage.getItem(SS_ROLE);
  useEffect(() => {
    dispatch(
      fetchAllApprovalList({
        dateRange: "",
        page: 0,
        size: 10,
        activeStatus: "",
        onBoardedStatus: status,
        userRefId: "",
      })
    );
  }, []);

  return (
    <div>
      <div style={{ padding: "0px 20px", overflow: "hidden" }}>
        <CustomTable
          styles={{
            maxHeight: height * 0.7,
            minHeight: height * 0.7,
          }}
          data={approvalData?.clients}
          currentPage={approvalData?.currentPageNo - 1}
          headers={
            role === ADMIN
              ? ApprovedListHeadersAdmin
              : role === ADMIN_USER
              ? ApprovedListHeadersAdmin
              : role === RNC
              ? ApprovedListHeadersRnc
              : ""
          }
          totalElements={approvalData?.totalRecords}
          totalPages={approvalData?.totalPages}
          handlePaginate={(page) => {
            setCurrentPage(page);
            dispatch(
              fetchAllApprovalList({
                dateRange: "",
                page: page + 1,
                size: 10,
                // activeStatus: "",
                onBoardedStatus: status,
                userRefId: "",
              })
            );
          }}
          onViewMore={(row) => {
            onChange(true, row);
            // setClientData(row);
            setOnClickViewMore(true);
          }}
        />
      </div>

      {onClickViewMore && (
        <CustomModal
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
          open={onClickViewMore}
          isBackRequired={false}
          isHeaderRequired={false}
          onClose={() => {
            setOnClickViewMore(false);
          }}
        >
          <ViewMoreApproval
            onClose={() => {
              setOnClickViewMore(false);
            }}
            data={clientData}
            isButtonsRequired={false}
            onSuccess={() => {}}
          />
        </CustomModal>
      )}
    </div>
  );
}

export default Approved;
